import { assertNever } from 'owa-assert';
import { getUserMailboxInfo, MailboxInfo, MailboxType } from 'owa-client-ids';
import createExplicitLogonRequest from './createExplicitLogonRequest';
import { getConnectedAccountHeaders } from './getDefaultRequestHeaders';
import { HeadersWithoutIterator } from './types/HeadersWithoutIterator';
import { RequestOptions } from './types/RequestOptions';
import { setHeaders } from './utils/setHeaders';

export default async function getDefaultRequestOptions(
    mailboxInfo: MailboxInfo
): Promise<RequestOptions | null> {
    if (mailboxInfo) {
        switch (mailboxInfo.type) {
            case MailboxType.GroupMailbox:
                return createExplicitLogonRequest(mailboxInfo.deprecatedMailboxId, mailboxInfo);
            case MailboxType.UserMailbox:
                let defaultRequestOptions: RequestOptions = mailboxInfo.requestOptions;
                if (!defaultRequestOptions) {
                    defaultRequestOptions = {
                        headers: new Headers(),
                    };
                }

                // for all non-primary, connected accounts, get the token and anchor mailbox from owa-accounts-store
                if (mailboxInfo.primarySmtpAddress != getUserMailboxInfo().primarySmtpAddress) {
                    defaultRequestOptions.headers = await getHeadersForConnectedAccount(
                        mailboxInfo.primarySmtpAddress
                    );
                    defaultRequestOptions.authNeededOnUnAuthorized = false;
                }
                return defaultRequestOptions;
            default:
                return assertNever(mailboxInfo.type);
        }
    } else {
        return null;
    }
}

async function getHeadersForConnectedAccount(
    primarySmtpAddress: string
): Promise<HeadersWithoutIterator> {
    const headers = new Headers();

    const connectedAccountHeaders = await getConnectedAccountHeaders(primarySmtpAddress);
    setHeaders(headers, connectedAccountHeaders);

    return headers;
}
